const invertedMessages = {
  'Refresh progress data': 'certs.refresh.progress',
  Toggle: 'certs.toggle',
};

export default invertedMessages;
